__turbopack_context__.v({
  "carousel": "BlockRelatedPages-module-scss-module__xaooXW__carousel",
  "fade-in": "BlockRelatedPages-module-scss-module__xaooXW__fade-in",
  "header": "BlockRelatedPages-module-scss-module__xaooXW__header",
  "headline": "BlockRelatedPages-module-scss-module__xaooXW__headline",
  "jaggedTop": "BlockRelatedPages-module-scss-module__xaooXW__jaggedTop",
  "link": "BlockRelatedPages-module-scss-module__xaooXW__link",
  "root": "BlockRelatedPages-module-scss-module__xaooXW__root",
  "slide": "BlockRelatedPages-module-scss-module__xaooXW__slide",
});
